/* tslint:disable */
/* eslint-disable */
export enum ExcelDocumentHandlerTypeEnum {
  Default = 'Default',
  Current = 'Current',
  Future = 'Future',
  Changed = 'Changed',
  Missing = 'Missing'
}
